// data.js
// Team member data for the "Counsel" team page.
// Each member has a short `bio` (shown on the card) and an optional
// `details` object (shown inside the popup when the card is clicked).
// Members without a `details` object will just show their short bio
// in the popup — so you can add depth to any profile over time without
// breaking the others.

import t1 from "../../assets/images/team/t1.jpeg";
import t2 from "../../assets/images/Founder-image/founder.jpg";
export const BURGUNDY = "#6D0C22";
export const teamMembers = [
    {
    id: 1,
    name: "Kuldeep Rai",
    role: "Advocate — Supreme Court of India",
    bio: "An advocate practising before the Supreme Court of India since 2016, with a diverse practice spanning writ matters, service matters, criminal matters, bail matters, public interest litigation, and matters involving the Enforcement Directorate.",
    // Local image. Copy the file `assets/team/kuldeep-rai.jpg` (included
    // alongside this data.js) into your project's public/ or assets/
    // folder, and adjust this path to match where you serve it from.
    image: t2,
    social: { linkedin: "#", twitter: "#" },
    details: {
      intro:
        "Advocate Kuldeep Rai completed his Bachelor of Laws (LL.B.) from the University of Calcutta in 2013, followed by a Master of Laws (LL.M.) in 2015. He commenced his professional journey in litigation at the Calcutta High Court and, in 2016, shifted his practice to the Supreme Court of India. Since then, he has developed a diverse and extensive practice across various branches of law, appearing and arguing matters before several High Courts across the country.",
      practiceAreas: [
        {
          title: "Writ Matters",
          desc: "Writ petitions and related constitutional remedies before the Supreme Court and various High Courts.",
        },
        {
          title: "Service Matters",
          desc: "Disputes concerning service conditions, employment and administrative matters involving government and public sector employees.",
        },
        {
          title: "Criminal Matters",
          desc: "Criminal litigation including trials, complaints, appeals and related proceedings.",
        },
        {
          title: "Bail Matters",
          desc: "Bail applications and related proceedings before trial courts, High Courts and the Supreme Court.",
        },
        {
          title: "Public Interest Litigation (PIL)",
          desc: "Matters filed in the public interest before constitutional courts.",
        },
        {
          title: "Enforcement Directorate (ED) Matters",
          desc: "Representation in matters involving the Enforcement Directorate, including related investigations and proceedings.",
        },
        {
          title: "Criminal & Other Trials",
          desc: "Conducting criminal trials and other trial proceedings across various courts.",
        },
      ],
      courts: [
        "Supreme Court of India",
        "Calcutta High Court",
        "Bombay High Court",
        "Telangana High Court",
        "Karnataka High Court",
        "Allahabad High Court",
        "Lucknow Bench of the Allahabad High Court",
      ],
      approach:
        "Advocate Kuldeep Rai has built a diverse and extensive practice across various branches of law since shifting his practice to the Supreme Court of India in 2016, appearing and arguing important matters before multiple High Courts across the country.",
      experience: {
        period: "2013 – Present",
        text: "Kuldeep Rai commenced his professional journey in litigation at the Calcutta High Court after completing his LL.B. in 2013 and LL.M. in 2015. In 2016, he shifted his practice to the Supreme Court of India, since when he has appeared and argued important matters before various High Courts across the country, including the Bombay High Court, Telangana High Court, Karnataka High Court, Allahabad High Court, the Lucknow Bench of the Allahabad High Court, and the Calcutta High Court, among others.",
      },
      education: [
        { degree: "LL.M.", institution: "", year: "2015" },
        { degree: "LL.B.", institution: "University of Calcutta", year: "2013" },
      ],
      corePractice: [
        "Supreme Court Litigation",
        "Writ Matters",
        "Service Matters",
        "Criminal Law",
        "Bail Matters",
        "Public Interest Litigation",
        "Enforcement Directorate Matters",
      ],
    },
  },
{
    id: 2,
    name: "Vijay Singh",
    role: "Advocate — Supreme Court of India, High Courts, District Courts & Tribunals",
    bio: "A litigation counsel practising since 2019 before the Supreme Court of India, various High Courts, District Courts across Delhi-NCR, and specialised tribunals — handling civil, criminal, constitutional, commercial and IP matters.",
    // Local image. Copy the file `assets/team/vijay-singh.jpg` (included
    // alongside this data.js) into your project's public/ or assets/
    // folder, and adjust this path to match where you serve it from.
    image: t1,
    social: { linkedin: "#", twitter: "#" },
    details: {
      intro:
        "Advocate Vijay Singh is a litigation counsel practising since 2019, with professional experience before the Supreme Court of India, various High Courts, District Courts across Delhi-NCR, and specialised tribunals and forums. He holds a B.A. LL.B. from Aligarh Muslim University (2019) and an LL.M. in Intellectual Property Rights (IPR). Since commencing legal practice, he has been engaged in litigation and legal representation across a diverse range of civil, criminal, constitutional, commercial, matrimonial, employment, consumer, corporate and intellectual-property matters. His practice involves proceedings before multiple judicial and quasi-judicial forums, requiring detailed legal research, strategic case preparation, precise drafting and effective courtroom advocacy.",
      practiceAreas: [
        {
          title: "Supreme Court & High Court Litigation",
          desc: "Writ petitions, appeals, revisions, special leave matters and other proceedings before constitutional courts.",
        },
        {
          title: "Civil & Commercial Litigation",
          desc: "Civil suits, commercial disputes, contractual matters, property disputes, injunctions and related proceedings.",
        },
        {
          title: "Criminal Litigation",
          desc: "Bail matters, quashing petitions, criminal complaints, revisions, appeals and proceedings arising from FIRs and criminal cases.",
        },
        {
          title: "Family & Matrimonial Law",
          desc: "Matrimonial disputes, domestic violence proceedings, maintenance matters and related civil and criminal proceedings.",
        },
        {
          title: "Intellectual Property Rights",
          desc: "Matters relating to trademarks, copyright, intellectual property protection, infringement disputes and related commercial proceedings.",
        },
        {
          title: "Labour & Employment Law",
          desc: "Labour disputes, employment matters, service-related proceedings and representation before labour courts, authorities and tribunals.",
        },
        {
          title: "Corporate & Insolvency Law",
          desc: "Proceedings before the National Company Law Tribunal (NCLT) and matters involving corporate and commercial disputes.",
        },
        {
          title: "Consumer Law",
          desc: "Representation before Consumer Commissions and forums in disputes concerning consumer rights, services and commercial transactions.",
        },
        {
          title: "Real Estate & Property Matters",
          desc: "Property disputes, contractual issues, possession-related matters and proceedings before relevant courts and authorities.",
        },
      ],
      courts: [
        "Supreme Court of India",
        "Various High Courts",
        "District & Sessions Courts across Delhi-NCR",
        "National Company Law Tribunal (NCLT)",
        "Consumer Commissions & Forums",
        "Labour Courts & Industrial Tribunals",
        "RERA Authorities and Appellate Forums",
        "Other Judicial & Quasi-Judicial Authorities",
      ],
      approach:
        "Advocate Vijay Singh approaches each matter with an emphasis on careful factual analysis, comprehensive legal research, precise drafting and focused courtroom advocacy. His practice across different courts and specialised forums enables him to handle matters involving complex factual backgrounds, multiple proceedings and diverse areas of law, while developing litigation strategies tailored to the specific circumstances of each case.",
      experience: {
        period: "2019 – Present",
        text: "Since graduating from Aligarh Muslim University, Advocate Vijay Singh has been engaged in active legal practice, appearing before the Supreme Court, various High Courts, District Courts across Delhi-NCR and specialised tribunals and forums. His practice encompasses both litigation and legal advisory work across civil, criminal, commercial, matrimonial, labour, consumer, corporate and intellectual-property matters.",
      },
      education: [
        { degree: "LL.M. — Intellectual Property Rights (IPR)", institution: "", year: "" },
        { degree: "B.A. LL.B.", institution: "Aligarh Muslim University", year: "2019" },
      ],
      corePractice: [
        "Supreme Court & High Court Litigation",
        "Civil & Criminal Law",
        "Constitutional Law",
        "Intellectual Property Rights",
        "Commercial & Corporate Disputes",
        "Matrimonial Law",
        "Labour & Employment",
        "NCLT Matters",
        "Consumer Law",
        "Real Estate",
      ],
    },
  },
];

export default teamMembers;